angular.module('gym.components').directive('calendarNavigation', function() {
  return {
    restrict: 'E',
    template: require('templates/components/calendar/calendar_navigation.html.slim'),
    scope: {
      toDate: '&',
      period: '=',
      startDate: '=',
      page: '@',
      locations: '=',
      instructors: '=',
      eventTypes: '=',
      styles: '=',
      selectedLocations: '=',
      selectedInstructors: '=',
      selectedEventTypes: '=',
      selectedStyles: '=',
      multiSelect: '=',
      displayOldEventsHiddenWarning: '=',
      oldEventDisplayThresholdDate: '=',
      unableToManageOtherContacts: '=',
      disableShowAllInstructors: '=',
      hideInstructor: '=',
      onLocationsChange: '&',
      onInstructorsChange: '&',
      onEventTypesChange: '&',
      onStylesChange: '&',
      currentViewName: '=',
      calendarView: '=',
      calendarTitle: '=',
      titleInline: '=',
      standalone: '=',
      timebarOnly: '=',
      hidePeriods: '=',
      params: '=',
      onParamsChange: '&'
    },
    controller: ["$scope", "$rootScope", "$state", "flash", "EmploymentService", "FeatureAvailabilityService", "GTMService", "EventService", function($scope, $rootScope, $state, flash, EmploymentService, FeatureAvailabilityService, GTMService, EventService) {
      $scope.permissions = EmploymentService.get().permissions;
      $scope.attendanceAvailable = FeatureAvailabilityService.isAvailable('attendance');
      $scope.isDatepickerOpen = false;
      $scope.glossary = $rootScope.gym.glossary;
      $scope.changeView = function(view) {
        switch (view) {
          case 'calendar':
            if ($scope.calendarView) {
              return $scope.calendarView.calendar.changeView('month');
            } else {
              return $state.go('gym.calendar', {
                view: 'calendar'
              });
            }
            break;
          case 'agenda':
            if ($scope.calendarView) {
              return $scope.calendarView.calendar.changeView('basicDay');
            } else {
              return $state.go('gym.calendar', {
                view: 'daily_agenda'
              });
            }
            break;
          case 'freeTrials':
            return $state.go('gym.freeTrials');
          case 'trainers':
            return $state.go('gym.trainers');
          case 'onlineMeetings':
            return $state.go('gym.onlineMeetings');
        }
      };
      $scope.changePeriod = function(period) {
        if ($scope.isPeriodActive(period)) {
          return;
        }
        switch (period) {
          case 'month':
            return $scope.calendarView.calendar.changeView('month');
          case 'week':
            switch (false) {
              case $scope.currentViewName !== 'basicDay':
                return $state.go('gym.weeklyAgenda');
              case $scope.currentViewName !== 'trainers':
                return $state.go('gym.weeklyTrainers');
              default:
                return $scope.calendarView.calendar.changeView('agendaWeek');
            }
            break;
          case 'day':
            switch (false) {
              case !$scope.calendarView:
                return $scope.calendarView.calendar.changeView('agendaDay');
              case $scope.currentViewName !== 'weeklyTrainers':
                return $state.go('gym.trainers');
              default:
                return $state.go('gym.calendar', {
                  view: 'daily_agenda'
                });
            }
        }
      };
      $scope.isViewActive = function(view) {
        var ref;
        switch (view) {
          case 'calendar':
            return !!$scope.calendarView && $scope.currentViewName !== 'basicDay';
          case 'agenda':
            return (ref = $scope.currentViewName) === 'basicDay' || ref === 'weeklyAgenda';
          default:
            return view === $scope.currentViewName;
        }
      };
      $scope.isPeriodActive = function(period) {
        var ref, ref1;
        switch (period) {
          case 'day':
            return (ref = $scope.currentViewName) === 'agendaDay' || ref === 'basicDay' || ref === 'trainers';
          case 'week':
            return (ref1 = $scope.currentViewName) === 'agendaWeek' || ref1 === 'weeklyAgenda' || ref1 === 'weeklyTrainers';
          case 'month':
            return $scope.currentViewName === 'month';
        }
      };
      $scope.toggleDatePicker = function() {
        $scope.isDatepickerOpen = !$scope.isDatepickerOpen;
        if ($scope.isDatepickerOpen) {
          return $scope.skipToDate = moment($scope.startDate).clone().toDate();
        }
      };
      $scope.onSkipToDateChange = function(date) {
        $scope.isDatepickerOpen = false;
        return $scope.toDate({
          date: moment(date, 'YYYY-MM-DD')
        });
      };
      $scope.switch = function(value) {
        var date, period;
        $scope.isDatepickerOpen = false;
        period = $scope.period + 's';
        date = moment($scope.startDate).clone().add(value, period);
        return $scope.toDate({
          date: date
        });
      };
      $scope.onAddAppointmentClick = function() {
        EventService.addAppointment();
        return GTMService.trackPage($scope.page, 'Add new appointment');
      };
      $scope.onAddEventClick = function() {
        EventService.addEvent();
        return GTMService.trackPage($scope.page, 'Add new event');
      };
      $scope.periodButtonsVisible = function() {
        return !$scope.hidePeriods && $scope.currentViewName !== 'freeTrials' && $scope.currentViewName !== 'onlineMeetings';
      };
      $scope.isToday = function() {
        var ref;
        return (ref = $scope.startDate) != null ? ref.isSame(moment(), $scope.period) : void 0;
      };
      return $scope.today = function() {
        return $scope.toDate({
          date: moment()
        });
      };
    }]
  };
});
